import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SingleDatePicker from "../../Components/SingleDatePicker";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { useParams } from "react-router-dom";
import SummaryCards from "../../Components/MarkAttendance/SummaryCards";
import { toast } from "react-toastify";

const MarkTenantAttendance = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const { id } = useParams();
  const [key, setKey] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedData, setSelectedData] = useState("");

  const [summary, setSummary] = useState({
    totalLeads: 0,
    newLeads: 0,
    followUpLeads: 0,
    visitedLeads: 0,
    convertedLeads: 0,
  });
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const query = `&propId=${id}&s=${searchQuery}&t=${filterType}&filter=${filter}&date=${selectedDate}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/attendance/property/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setSummary(res?.summary);
      setMasterData(res?.data);
      setIsFocused(true);
    }
  };

  const getError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  useEffect(() => {
    if (filterValue || selectedDate) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 300);

      return () => clearTimeout(handler);
    }
  }, [filterValue, selectedDate]);

  useEffect(() => {
    if (filter) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 200);

      return () => clearTimeout(handler);
    }
  }, [filter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);

    return () => clearTimeout(handler);
  }, [property]);

  const submitHandler = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
    setFilterType("");
    setSearchQuery("");
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => clearTimeout(handler);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => clearTimeout(handler);
  };

  const handleAttendanceToggle = async (tenantId, currentStatus) => {
    const isToday = moment(selectedDate).isSame(moment(), "day");

    if (!isToday) {
      toast.error("Attendance can only be marked for today's date");
      return;
    }
    try {
      const newStatus = currentStatus === 0 ? 1 : 0;
      const response = await axios.post(
        `${Config.apiUrl}/tenant/mark/attendance`,
        {
          tenantId,
          attendance: newStatus,
        },
        {
          headers: {
            authorization: "Bearer" + " " + user.token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.isSuccess) {
        toast.success(response.data.msg);
        getListMutate();
      }
    } catch (error) {
    
      toast.error(
        error.response.data.msg ||
          "Failed to update attendance. Please try again."
      );
    }
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Mark Attendance
          <Underline />
        </BoxTitle>
      </BoxHead>

      <FilterWrapper>
        <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
          <SearchFilterBox
            options={searchOptions}
            handleFilterChange={handleFilterChange}
            handleClearFilters={handleClearFilters}
          />
          <SingleDatePicker
            submitHandler={submitHandler}
            defaultLabel={moment(selectedDate).format("DD MMM YYYY")}
            initialDate={selectedDate}
          />
        </div>
      </FilterWrapper>

      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={5} />
      )}
      {isFocused && apiData && <SummaryCards data={data} />}

      {isFocused && apiData && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-8">
          {apiData.map((tenant) => (
            <TenantCard
              key={tenant.tenantId}
              tenant={tenant}
              onToggle={handleAttendanceToggle}
            />
          ))}
        </div>
      )}

      {(isLoading || isRefetching) && <Loading />}
      {error && !isLoading && <NotFoundModel />}
    </BoxContainer>
  );
};

const TenantCard = ({ tenant, onToggle }) => {
  const isPresent = tenant.status === 1;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-semibold text-lg text-gray-800">
            {tenant.tenantName}
          </h3>
          <p className="text-gray-600 text-sm mt-1">
            {tenant.propName} - {tenant.roomNum}
            {tenant.flatName && `, ${tenant.flatName}`}
          </p>
        </div>
        <AttendanceToggle
          isPresent={isPresent}
          onToggle={() => onToggle(tenant.tenantId, tenant.status)}
        />
      </div>
    </div>
  );
};

const AttendanceToggle = ({ isPresent, onToggle }) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={isPresent}
        onChange={onToggle}
        disabled={isPresent}
      />
      <div
        className={`w-11 h-6 rounded-full peer ${
          isPresent ? "bg-green-300" : "bg-red-300"
        }`}
      >
        <div
          className={`absolute top-0.5 left-[2px] bg-white border-gray-300 rounded-full h-5 w-5 transition-all ${
            isPresent ? "translate-x-full border-white" : "border"
          }`}
        ></div>
      </div>
      <span
        className={`ml-2 text-sm font-medium ${
          isPresent ? "text-green-600" : "text-red-600"
        }`}
      >
        {isPresent ? "Present" : "Absent"}
      </span>
    </label>
  );
};

const FilterWrapper = tw.div`flex w-full pb-4 lg:flex-row flex-col lg:gap-0 gap-4`;
export default MarkTenantAttendance;
